/**
 * Query params for GET /projects/:projectId/work-items/:workItemId/time-logs
 */

export const WORK_ITEM_TIME_LOG_SCOPE = {
  ALL: "all",
  MINE: "mine",
};

const DEFAULT_SORT_BY = "log_date";
const DEFAULT_SORT_ORDER = "DESC";
const DEFAULT_PAGE = 1;
const DEFAULT_LIMIT = 50;

/**
 * @param {{
 *   scope?: string;
 *   dateFrom?: string | null;
 *   dateTo?: string | null;
 *   page?: number;
 *   limit?: number;
 *   sortBy?: string;
 *   sortOrder?: string;
 * }} [options]
 */
export function buildWorkItemTimeLogsQueryParams({
  scope = WORK_ITEM_TIME_LOG_SCOPE.ALL,
  dateFrom = null,
  dateTo = null,
  page = DEFAULT_PAGE,
  limit = DEFAULT_LIMIT,
  sortBy = DEFAULT_SORT_BY,
  sortOrder = DEFAULT_SORT_ORDER,
} = {}) {
  const params = {
    scope: scope === WORK_ITEM_TIME_LOG_SCOPE.MINE ? "mine" : "all",
    page: Math.max(1, Number(page) || DEFAULT_PAGE),
    limit: Math.max(1, Number(limit) || DEFAULT_LIMIT),
    sortBy: sortBy || DEFAULT_SORT_BY,
    sortOrder: sortOrder || DEFAULT_SORT_ORDER,
  };
  if (dateFrom) params.dateFrom = dateFrom;
  if (dateTo) params.dateTo = dateTo;
  return params;
}
